import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import { DCService,SalesInvoiceService } from "../../../services/index";

@Component({
  selector: "add-edit-bitdc",
  templateUrl: "./addEditBitDc.html",
})
export class addEditBitDc {
  row: any;
  data: any;
  mode = "Add";
  dcdata: any = { dc_id: "", total_mtr: 0 };
  dcdata1: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  colorList: any;
  codeList: any;
  widthList = ["36", "44", "58"];
  sizeList: any;
  desData: any = {
    totDes: 0,
  };
  barcodeList = [];
  workOrderBarcodeList = [];
  brandList = [];
  partyList = [];
  styleList = ["BABLA", "SHIRT"];
  dctypeList = ["BIT", "BULK"];
  jobpartyList = []
  unitList: any;
  rd_season = [];
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  dcList = [
    {
      lump_no: "",
      design_no: "",
      color: "",
      fab_style: "",
      width: "",
      qty: 0,
      sf36: 0,
      sf38: 0,
      sf40: 0,
      sf42: 0,
      sf44: 0,
      sf46: 0,
      sh36: 0,
      sh38: 0,
      sh40: 0,
      sh42: 0,
      sh44: 0,
      sh46: 0,
      bf28: 0,
      bf30: 0,
      bf32: 0,
      bf34: 0,
      bf36: 0,
      bh28: 0,
      bh30: 0,
      bh32: 0,
      bh34: 0,
      bh36: 0,
      sftot: 0,
      shtot: 0,
      bftot: 0,
      bhtot: 0,
      tot: 0,
    },
  ];
  woList: any = [];
  noofpcs: number;
  export: boolean = false;
  printRes: any;
  printPreview = [];
  isLoadMask: Promise<any>;

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";

  isLoading = false;
  @Input() _params: any;
  dc_id: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    if (this.mode == "Edit" || this.mode == "View") {
      const designdata = Object.assign({}, val["data"]);
      this.dcdata = designdata;
      this.dcdata.party = designdata.jobparty;
      this.getdcdesignList(this.dcdata.dc_id);
      this.getbarcodeList();
      // this.onChangeCode()
    }
  }

  get params(): any[] {
    return this._params;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private dcService: DCService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesinvservice: SalesInvoiceService,
  ) {
    this.data = {
      dcdata1: [],
    };
  }
  ngOnInit() {
    if (this.mode == "Add") {
      this.dcdata.dc_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.getAuto();
      this.getRefAuto();
      // this.getbarcodeList();
      this.getBitPartyList();
      this.getjobWorkPartyList();
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#unit").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if (nextEl == "barcodegood") {
      $("#" + this.page_id + "barcode-0").focus();
    } else if (this.dcdata.dc_type == "BULK" && nextEl == "size") {
      $("#" + this.page_id + "barcode-0").focus();
    } else {
      $("#" + this.page_id + nextEl).focus();
    }
  }
  

  onGoToNextFld($event, fld, ind) {

  if(this.dcdata.dc_type == 'BULK' && fld == "barcode" && this.dcdata.style == 'BABLA'){
 
    $("#" + this.page_id + "bf28" + "-" + ind).focus();

    return false;
  }

  else if(this.dcdata.dc_type == 'BULK' && fld == "barcode" && this.dcdata.style == 'SHIRT'){
 
    $("#" + this.page_id + "sf36" + "-" + ind).focus();

    return false;
  }
    if (fld == "color") {
      let totdes = 0;
      const designlist = [];
      for (let i = 0; i < this.dcList.length; i++) {
        const design = this.dcList[i].design_no;
        if (design != "") {
          if (designlist.indexOf(design) == -1) {
            designlist.push(design);
            totdes++;
          }
        }
      }
      this.dcdata.total_design = totdes;
    }

    let nxtInd = ind,
      barcode = this.dcList[ind]["lump_no"],
      design = this.dcList[ind]["design_no"],
      color = this.dcList[ind]["color"],
      fab_style = this.dcList[ind]["fab_style"],
      width = this.dcList[ind]["width"],
      qty = this.dcList[ind]["qty"];
    this.calctot();

    const nxtRow = $("#row-" + ind).next("tr");
    if ((fld == "barcode" && nxtRow.length == 0) || (fld == "goodbarcode")) {
      if (this.dcList[ind].qty == 0) {
        swal({
          title:
            "Please Enter the Valid Mtr for design " +
            this.dcList[ind].design_no,
          timer: 1000,
          showConfirmButton: false,
        });
        return false;
      }

      if (this.dcList.length >= 101) {
        swal("Maximum bits reached");
        return false;
      }

      const len = this.dcList.length;
      const lump_no = this.dcList[len - 1]["lump_no"];
      const qty = this.dcList[len - 1].qty;
      nxtInd = nxtInd + 1;
      $("#" + this.page_id + "design" + "-" + nxtInd).focus();

      if (lump_no != "" && nxtInd == len) {
        this.dcList.push({
          lump_no: "",
          design_no: "",
          color: "",
          fab_style: "",
          width: "",
          qty: 0,
          sf36: 0,
          sf38: 0,
          sf40: 0,
          sf42: 0,
          sf44: 0,
          sf46: 0,
          sh36: 0,
          sh38: 0,
          sh40: 0,
          sh42: 0,
          sh44: 0,
          sh46: 0,
          bf28: 0,
          bf30: 0,
          bf32: 0,
          bf34: 0,
          bf36: 0,
          bh28: 0,
          bh30: 0,
          bh32: 0,
          bh34: 0,
          bh36: 0,
          sftot: 0,
          shtot: 0,
          bftot: 0,
          bhtot: 0,
          tot: 0,
        });

        $("#" + this.page_id + "barcode" + "-" + nxtInd).focus();
        this.calctot();
      }
      
      else if (barcode == "" && nxtInd == len) {
        const a = nxtInd - 1;
        $("#" + this.page_id + "barcode" + "-" + a).focus();
      } 
    
      else {
        $("#" + this.page_id + "barcode" + "-" + nxtInd).focus();

        return false;
      }
    }

    //   nxtInd = this.designList.length - 1;
    else if (fld == "item_name") {
      const nxtRowID = nxtRow[0].id;
      nxtInd = nxtRowID.split("-")[1];
    } else {
      setTimeout(() => {
        $("#" + this.page_id + fld + "-" + nxtInd).focus();
      }, 200);
    }
  }

  isRowEmpty(ind) {
    const data = this.dcList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onChangeSize(size) {
    this.getbarcodeList();
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    const that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.dcList.length > 1) {
          that.dcList.splice(ind, 1);
          let totdes = 0;
          const designlist = [];
          for (let i = 0; i < that.dcList.length; i++) {
            const design = that.dcList[i].design_no;
            if (design != "") {
              if (designlist.indexOf(design) == -1) {
                designlist.push(design);
                totdes++;
              }
            }
          }
          // that.dcdata.total_design = totdes;

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getRefAuto() {
    this.dcService.getBitRefAuto({}).then((res: any) => {
      this.dcdata.ref_no = res;
    });
  }

  getAuto() {
    this.dcService.getBitdcAuto({}).then((res: any) => {
      this.dcdata.dc_no = res;
    });
  }
  onSelect() {
    if (this.dcdata.dc_type == "BULK") {
      this.getbarcodeList();
    }
  }
  onClickCode(party_code) {
    const partyCodeList = _.filter(this.codeList, { code: party_code });
    this.dcdata.party_id = partyCodeList[0]["party_id"];
    this.dcdata.party_name = partyCodeList[0]["party_name"];
  }

  onclickunit(dept) {
    const partyCodeList = _.filter(this.unitList, { dept_name: dept });
    this.dcdata.dept_id = partyCodeList[0]["dept_id"];
  }
  getbarcodeList() {
    let params = {
      size: this.dcdata.size,
      brand: this.dcdata.brand,
      style: this.dcdata.style,
      width: this.dcdata.width,
      dc_type: this.dcdata.dc_type,
    };
    this.dcService.bitbarcodelist(params).then((res: any) => {
      this.barcodeList = res.data;
      for (let i = 0; i < this.barcodeList.length; i++) {
        this.barcodeList[i].barcode = this.barcodeList[i].barcode
          .toString()
          .padStart(6, "0");
      }
    });
  }

  getBitPartyList() {
    this.dcService.getBitPartyList({}).then((res: any) => {
      this.partyList = res.data;
    });
  }
  getjobWorkPartyList() {
    // this.dcService.getjobWorkPartyList({}).then((res: any) => {
    //   this.jobpartyList = res.data;
    // });

    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.jobpartyList = res;
    });
  }
  onselectPartyid(type){
    // let Data = this.jobpartyList.filter((el) => el.party_name == type);
    // this.dcdata.jobparty_id = Data[0].party_id;
    let Data = this.jobpartyList.filter((el) => el.name == type)
     this.dcdata.jobparty_id = Data[0].genLedid;
     console.log(Data);
  }
  onChangeParty(party) {
    let partyData = this.partyList.filter((el) => el.party_name == party);
    this.dcdata.party_id = partyData[0]["party_id"];
  }

  //onselectstyle
  onSelectStyle(style) {
    if (style == "BABLA") {
      this.brandList = ["LEO BOYS", "JOB"];
      this.dcdata.brand = "LEO BOYS";
      this.sizeList = [
        "F28",
        "F30",
        "F32",
        "F34",
        "F36",
        "H28",
        "H30",
        "H32",
        "H34",
        "H36",
      ];
    } else {
      // this.brandList = ["EXPOSE", "OLIVE"];
      this.brandList = ["EXPOSE", "OLIVE","LE MERITIN", "MARX", "JOB"];

      // this.dcdata.brand = "EXPOSE";
      this.sizeList = [
        "F36",
        "F38",
        "F40",
        "F42",
        "F44",
        "F46",
        "H36",
        "H38",
        "H40",
        "H42",
        "H44",
        "H46",
      ];
    }
  }
  getdcdesignList(id) {
    const params = {
      dc_id: id,
    };
    this.dcService.dcBitDesignList(params).then((res: any) => {
      this.dcList = res.data;
      for (let i = 0; i < this.dcList.length; i++) {
        this.dcList[i].lump_no = this.dcList[i].lump_no
          .toString()
          .padStart(6, "0");
      }
      this.calcPieces();
    });
  }
  //Barcode Reader

  onChangeCode(barcode, design, ind) {
    if (barcode.length == 6) {
      const data = _.filter(this.barcodeList, { barcode: barcode });
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.lump_no == barcode) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.design_no = "";
        design.color = "";
        design.width = "";
        design.qty = "";
        design.fab_style = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Barcode Already Exists",
        });
      } else {
        if (data.length <= 0) {
          design.design_no = "";
          design.color = "";
          design.width = "";
          design.qty = "";
          design.fab_style = "";
          swal(
            "Please enter valid barcode for width - " +
              this.dcdata.width +
              "-" +
              this.dcdata.style +
              " - " +
              this.dcdata.size
          );
          return;
        }

        design.id = data[0]["id"];
        design.design_no = data[0]["design_no"];
        design.color = data[0]["color"];
        design.width = data[0]["width"];
        // design.party_design = data[0]["party_design"];
        design.size = data[0]["size"];
        design.fab_style = data[0]["fab_style"];
        design.qty = data[0]["mtrs"] > 0 ? data[0]["mtrs"] : 0;

        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].design_no;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
        // this.dcdata.total_design = totdes;
        this.calcRate(ind);
      }
    }
  }
  checkQty(qty, row, ind) {
    this.barcodeList;
    let that = this;
    this.barcodeList.forEach(function (element) {
      if (row.lump_no == element.barcode) {
        if (qty > element.mtrs) {
          that.barcodeList[0].qty = 0;
          that.dcList[ind].qty = 0;
        }
      }
    });
    if (qty > row.qty) {
      this.dcList[ind].qty = 0;
    }
  }
  onSelectItem($event, design, ind) {
    // debugger;
    const barcode = $event.item.barcode;
    if (barcode.length == 6) {
      let exists = false;
      for (let i = 0; i < this.dcList.length; i++) {
        const li = this.dcList[i];
        if (i !== ind) {
          if (li.lump_no == barcode) {
            exists = true;
            break;
          }
        }
      }
      if (exists) {
        design.design_no = "";
        design.color = "";
        design.width = "";
        design.qty = "";
        design.fab_style = "";
        // design.party_design = "";
        // design.size = "";

        this.toasterService.pop({
          bodyOutputType: 1,
          type: "error",
          title: "Barcode Already Exists",
        });
      } else {
        if (!$event.item.id) {
          swal(
            "Please enter valid barcode for width - " +
              this.dcdata.width +
              "-" +
              this.dcdata.style +
              " - " +
              this.dcdata.size
          );
          return;
        }

        design.design_no = $event.item.design_no;
        // design.party_design = $event.item.party_design;
        design.id = $event.item.id;
        design.color = $event.item.color;
        design.width = $event.item.width;
        design.fab_style = $event.item.fab_style;
        design.qty = $event.item.mtrs > 0 ? $event.item.mtrs : 0;

        let totdes = 0;
        const designlist = [];
        for (let i = 0; i < this.dcList.length; i++) {
          const design = this.dcList[i].design_no;
          if (design != "") {
            if (designlist.indexOf(design) == -1) {
              designlist.push(design);
              totdes++;
            }
          }
        }
        // this.dcdata.total_design = totdes;
        this.calctot();
      }
    }
  }

  oncheckemptyrow() {
    const design = this.dcList;
    const desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].lump_no != "") {
        desList.push(design[i]);
      }
    }
    this.dcList = desList;
    this.onSaveOrder();
  }
  calctot() {
 
    let totmtr = 0;
    for (let i = 0; i < this.dcList.length; i++) {
      const dcdata = this.dcList[i];
      totmtr += dcdata.qty;
    }

    this.dcdata.total_mtr = totmtr;
  }

  calcPieces() {
    this.dcList.forEach((el) => {
      el.sftot =
        Number(el.sf36) +
        Number(el.sf38) +
        Number(el.sf40) +
        Number(el.sf42) +
        Number(el.sf44) +
        Number(el.sf46);

      el.shtot =
        Number(el.sh36) +
        Number(el.sh38) +
        Number(el.sh40) +
        Number(el.sh42) +
        Number(el.sh44) +
        Number(el.sh46);

      el.bftot =
        Number(el.bf28) +
        Number(el.bf30) +
        Number(el.bf32) +
        Number(el.bf34) +
        Number(el.bf36);
      el.bhtot =
        Number(el.bh28) +
        Number(el.bh30) +
        Number(el.bh32) +
        Number(el.bh34) +
        Number(el.bh36);

      el.tot =
        Number(el.sftot) +
        Number(el.shtot) +
        Number(el.bhtot) +
        Number(el.bftot);
    });
    this.calcRate("");
  }
  calcRate(type) {
    let item = this.dcList;
    let totqty = 0;
    if (this.dcdata.dc_type == "BIT") {
      // for (let i = 0; i < item.length; i++) {
      //   totqty += Number(item[i].totqty);
      // }
      totqty = type + 1;
    } else {
      this.dcList.forEach((el) => {
        totqty += Number(el.tot);
      });
    }
    this.dcdata.total_design = totqty;
  }
  onSaveOrder(): void {
    if (
      (!this.dcdata.unit ||
        !this.dcdata.brand ||
        !this.dcdata.style ||
        !this.dcdata.dc_no) &&
      this.dcdata.dc_type == "BIT"
    ) 
      
    {
      swal("Please make sure all are entered");
    }
    else if (
      (!this.dcdata.unit ||
        !this.dcdata.brand ||
        !this.dcdata.style ||
        !this.dcdata.party ||
        !this.dcdata.dc_no) &&
      this.dcdata.dc_type == "BULK"
    ) 
      
    {
      swal("Please make sure all are entered");
    }
     else {
      const params: any = Object.assign({}, this.dcdata);
      params["tabevent"] = undefined;
      params["dcList"] = JSON.stringify(this.dcList);
      //  params['workorder'] = this.dcdata.workorder || '';
      params["mode"] = this.mode;
      params["dc_date"] = this.datePipe.transform(
        params["dc_date"],
        "yyyy-MM-dd"
      );
      const that = this;
      that.isLoading = true;
      swal({
        title: "Are you sure to save this Job Work Dc?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.dcService
          .addUpdateBitDC(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }

            if (res.response.success) {
              that.printRes = res;

              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });

              const tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            const res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/bitDc/addEditBitDc.ts